import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { getStatusColor, getJobTypeToActionMapping } from 'common/jobConstants';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrPhotosModal from 'client/components/SrPhotosModal/SrPhotosModal';

const SrSunSetupListingOrderJob = ({ job, showPhotos, listing }) => {
  const [showPhotosModal, setShowPhotosModal] = useState(false);

  const _shouldDisplayPhotos = () => {
    return (
      job.completionPhotoUrls &&
      Array.isArray(job.completionPhotoUrls) &&
      job.completionPhotoUrls.length > 0 &&
      showPhotos
    );
  };

  const shouldDisplayPhotos = _shouldDisplayPhotos();

  return (
    <>
      <SrBox>
        <SrBox>
          <SrText fontSize="16px" font="greycliff">
            {getJobTypeToActionMapping({ job, listing }) || 'Missing Job Name'}
          </SrText>
        </SrBox>
        <SrBox>
          <SrText fontSize="14px" weight="600" font="greycliff" color={getStatusColor(job.status)}>
            {job.status}
          </SrText>
        </SrBox>
        {shouldDisplayPhotos && (
          <SrBox onClick={() => setShowPhotosModal(true)}>
            <SrText cursor="pointer" font="greycliff" color="blue300" fontSize="12px" weight="600">
              See Photos
            </SrText>
          </SrBox>
        )}
      </SrBox>
      {showPhotosModal && (
        <SrPhotosModal
          photos={job.completionPhotoUrls || []}
          onClose={() => setShowPhotosModal(false)}
          downloadDisabled
        />
      )}
    </>
  );
};

SrSunSetupListingOrderJob.propTypes = {
  job: PropTypes.object.isRequired,
  showPhotos: PropTypes.bool,
  listing: PropTypes.object.isRequired,
};

SrSunSetupListingOrderJob.displayName = 'SrSunSetupListingOrderJob';

export default SrSunSetupListingOrderJob;
